import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Router } from '@angular/router';
import { DialogReplyService } from 'src/app/services/Non-Master/DialogReply.service';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { tPatientService } from 'src/app/services/tPatient.service';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { tPatientModel } from 'src/app/models/tPatientModel';
// import {of,} from 'rxjs';
// import {delay} from 'rxjs/operators';
import { FormControl } from '@angular/forms';

import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
import { isNullOrUndefined } from 'util';
import { SimpleConfigService } from 'src/app/services/SimpleConfig.service';
import { GenderModel, GenderTitleModel } from 'src/app/models/SimpleConfigModel';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-patient-dialog',
  templateUrl: './patient-dialog.component.html',
  styleUrls: ['./patient-dialog.component.css']
})



export class PatientDialogComponent implements OnInit {

  unSelectedList;
  patientTitleList;
  patientGenderList;
  patientTypeList;

  showEng = false;

  displayMoreFilter = false;

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private dialogReplyService: DialogReplyService,
    private tPatientService: tPatientService,
    private CrypService: CrypService,
    private SimpleConfigService:SimpleConfigService,
    private translateService:TranslateService

  ) {
    translateService.use(localStorage.getItem("currentLanguage"));
   }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private TAG = 'PatientDialogComponent';
  dataSource: MatTableDataSource<tPatientModel>;
  checkLoadingDataSource: any;

  displayedColumns: string[] = [
    'patientID',
    // 'pTypeDesc',
    'patientChiNameAll',
    'patientSurname',
    'patientPhone',
    'patientIHKID',
    // 'patientRemark2',
    'patientMedCard1',
    'caseDoctor'

  ];

  // search
  patientIDFilter = new FormControl();
  patientTypeNameFilter = new FormControl();

  chiNameFilter = new FormControl();
  surNameFilter = new FormControl();
  firstNameFilter = new FormControl();
  patientNameFilter = new FormControl();

  phoneNoFilter = new FormControl();
  phoneNo2Filter = new FormControl();
  // packageAcctNameFilter = new FormControl();

  HKIDFilter = new FormControl();
  patientMedCard1Filter = new FormControl();
  patientRefereeFilter = new FormControl();
  RefereeRelationFilter = new FormControl()
  caseDoctorFilter = new FormControl()

  filteredValues = {

    patientID : '',
    patientTypeName: '',

    patientChiName: '',
    patientSurname: '',
    patientFirstName: '',
    patientName:'',

    patientPhone: '',
    patientPhone2: '',
    packageAcctName: '',

    patientIHKID: '',
    patientMedCard1: '',
    patientReferee:'',
    patientRefereeRelation:'',

    caseDoctor:''

  };

  // loading spinner
  isLoading = true;

  rowCount = 0;


  ngOnInit() {
    //this.setDefaultLanguageString(localStorage.getItem('currentLanguage'));
    this.setDefaultLanguageString(AppComponent.usingLanguage);
    this.translateService
    this.getGender();
    this.resetSearch();

    // if (!isNullOrUndefined(localStorage.getItem('systemMasterPatientID'))) {

    //   this.patientIDFilter.setValue(localStorage.getItem('systemMasterPatientID'));
    //   localStorage.removeItem('systemMasterPatientID');

    //   this.search();
    // }

    // this.getCount();

  }

  resetSearch() {

    this.isLoading = false;

    this.patientIDFilter.setValue('');
    this.patientTypeNameFilter.setValue('');

    this.chiNameFilter.setValue('');
    this.surNameFilter.setValue('');
    this.firstNameFilter.setValue('');
    this.patientNameFilter.setValue('');

    this.phoneNoFilter.setValue('');
    this.phoneNo2Filter.setValue('');
    // this.packageAcctNameFilter.setValue('');

    this.HKIDFilter.setValue('');
    this.patientMedCard1Filter.setValue('');
    this.patientRefereeFilter.setValue('');
    this.RefereeRelationFilter.setValue('');
    this.caseDoctorFilter.setValue('');
    this.dataSource = new MatTableDataSource<tPatientModel>();
    this.dataSource.paginator = this.paginator;
  }

  search() {
    this.log.i(this.TAG, ' getDataByPara');

    this.dataSource = new MatTableDataSource<tPatientModel>();
    this.dataSource.paginator = this.paginator;
    this.isLoading = true;

    const SearchParaJSON = [];
    const LineUploadJSON = [];

    const SchpatientIHKID = isNullOrUndefined(this.HKIDFilter.value) ? '' : this.HKIDFilter.value.trim();


    this.filteredValues = {

      patientID : (isNullOrUndefined(this.patientIDFilter.value) ? '' : this.patientIDFilter.value.trim()),
      patientTypeName: (isNullOrUndefined(this.patientTypeNameFilter.value) ? '' : this.patientTypeNameFilter.value.trim()),

      patientChiName: (isNullOrUndefined(this.chiNameFilter.value) ? '' : this.chiNameFilter.value.trim()),
      patientSurname: (isNullOrUndefined(this.surNameFilter.value) ? '' : this.surNameFilter.value.trim()),
      patientFirstName: (isNullOrUndefined(this.firstNameFilter.value) ? '' : this.firstNameFilter.value.trim()),
      patientName: (isNullOrUndefined(this.patientNameFilter.value) ? '' : this.patientNameFilter.value.trim()),

      patientPhone: (isNullOrUndefined(this.phoneNoFilter.value) ? '' : this.phoneNoFilter.value.trim()),
      patientPhone2: (isNullOrUndefined(this.phoneNo2Filter.value) ? '' : this.phoneNo2Filter.value.trim()),
      packageAcctName: '',
      // packageAcctName: (isNullOrUndefined(this.packageAcctNameFilter.value) ? '' : this.packageAcctNameFilter.value.trim()),

      patientIHKID: (SchpatientIHKID),
      patientMedCard1: (isNullOrUndefined(this.patientMedCard1Filter.value) ? '' : this.patientMedCard1Filter.value.trim()),
      patientReferee:(isNullOrUndefined(this.patientRefereeFilter.value) ? '' : this.patientRefereeFilter.value.trim()),
      patientRefereeRelation:(isNullOrUndefined(this.RefereeRelationFilter.value) ? '' : this.RefereeRelationFilter.value.trim()),
      caseDoctor:(isNullOrUndefined(this.caseDoctorFilter.value) ? '' : this.caseDoctorFilter.value.trim()),
    };


    const LineUploadJSONRaw = {};

    LineUploadJSON.push(this.filteredValues);

    const SearchParaJSONRaw = {
      line: LineUploadJSON
    };
   SearchParaJSON.push(SearchParaJSONRaw);


    const isSearch = 'Y';
    const rowFrom = 1;
    const nextRow = 50;

   this.log.i(this.TAG, 'SearchParaJSON = ' + JSON.stringify(SearchParaJSON));
    // this.tPatientService.getAllDataWithPatientTypeInfoByRange(rowFrom, nextRow, SearchParaJSON, isSearch).subscribe(data => {
      this.tPatientService.getAllDataWithPatientTypeInfoByRangeV2(rowFrom, nextRow, SearchParaJSON, isSearch).subscribe(data => {



      this.isLoading = false;

      data.forEach(element => {
        const patientPhone_d = this.CrypService.decryptStr(element.patientPhone_str);
        element.patientPhone = +patientPhone_d;

        const patientPhone2_d = this.CrypService.decryptStr(element.patientPhone2_str);
        element.patientPhone2 = +patientPhone2_d;

        const patientIHKID_d = this.CrypService.decryptStr(element.patientIHKID);
        element.patientIHKID = patientIHKID_d.toString();

        if (SchpatientIHKID !== '' && element.patientIHKID === '') {
          element.patientIHKID = 'NOHKID';
        }

      });



      this.log.i(this.TAG, 'SearchParaJSON = ' + JSON.stringify(data));

      if (SchpatientIHKID !== '') {
        this.dataSource = new MatTableDataSource<tPatientModel>(data.filter(l => l.patientIHKID !== 'NOHKID'));
      } else {
        this.dataSource = new MatTableDataSource<tPatientModel>(data);
      }


      // if (fromSearch === 'Y') {
      //   this.dataSource.paginator = this.paginator;
      // }

      this.dataSource.paginator = this.paginator;


    });
  }









  // getCount(): void {

  //   this.tPatientService.getCount().subscribe(count => {
  //     this.rowCount = count;

  //     this.getAllData();
  //   });
  // }


  // getAllData(): void {
  //   this.log.i(this.TAG, ' getAllProducts');

  //   const SearchParaJSON = [];
  //   const LineUploadJSON = [];

  //   const LineUploadJSONRaw = {};
  //   LineUploadJSON.push(LineUploadJSONRaw);

  //   const SearchParaJSONRaw = {
  //     line: LineUploadJSON
  //   };
  //   SearchParaJSON.push(SearchParaJSONRaw);

  //   this.tPatientService.getAllDataWithPatientTypeInfoByRange(0, 5, SearchParaJSON, 'N').subscribe(data => {
  //   // this.tPatientService.getAllDataWithPatientTypeInfo().subscribe(data => {

  //     data.forEach(element => {
  //       const patientPhone_d = this.CrypService.decryptStr(element.patientPhone_str);
  //       element.patientPhone = +patientPhone_d;

  //       const patientPhone2_d = this.CrypService.decryptStr(element.patientPhone2_str);
  //       element.patientPhone2 = +patientPhone2_d;

  //       const patientIHKID_d = this.CrypService.decryptStr(element.patientIHKID);
  //       element.patientIHKID = patientIHKID_d.toString();
  //     });



  //     this.dataSource = new MatTableDataSource<tPatientModel>(data);
  //     // this.dataSource.paginator = this.paginator;

  //     this.log.i(this.TAG, 'getAllDataWithPatientTypeInfo data = ' + JSON.stringify(data));

  //     // loading spinner
  //     this.isLoading = false;
  //     this.checkLoadingDataSource = data;
  //     // table sort
  //     this.dataSource.sort = this.sort;

  //     // search
  //     this.chiNameFilter.valueChanges.subscribe((chiNameFilterValue) => {
  //       this.filteredValues['patientChiName'] = chiNameFilterValue;
  //       this.dataSource.filter = JSON.stringify(this.filteredValues);

  //       this.getDataByPara(0, 50, 'Y');
  //     });

  //     this.phoneNoFilter.valueChanges.subscribe((phoneNoFilterValue) => {
  //       this.filteredValues['patientPhone'] = phoneNoFilterValue;
  //       this.dataSource.filter = JSON.stringify(this.filteredValues);

  //       this.getDataByPara(0, 50, 'Y');
  //     });

  //     this.HKIDFilter.valueChanges.subscribe((HKIDFilterValue) => {
  //       this.filteredValues['patientIHKID'] = HKIDFilterValue;
  //       this.dataSource.filter = JSON.stringify(this.filteredValues);

  //       this.getDataByPara(0, 50, 'Y');
  //     });

  //     this.patientMedCard1Filter.valueChanges.subscribe((value) => {
  //       this.filteredValues['patientMedCard1'] = value;
  //       this.dataSource.filter = JSON.stringify(this.filteredValues);

  //       this.getDataByPara(0, 50, 'Y');
  //     });

  //     this.dataSource.filterPredicate = this.customFilterPredicate();

  //   },
  //   error => this.isLoading = false);
  // }


  // getPaginatorData_NextRow(event) {

  //   // this.log.i(this.TAG + ' page event: ', JSON.stringify(event));

  //   this.log.i(this.TAG + ' page event: ', event.pageIndex * event.pageSize + 1);
  //   this.log.i(this.TAG + ' page event: ', event.pageIndex * event.pageSize + event.pageSize);


  // //   console.log(event);
  // //   if(event.pageIndex === this.pageIndex + 1){
  // //      this.lowValue = this.lowValue + this.pageSize;
  // //      this.highValue =  this.highValue + this.pageSize;
  // //     }
  // //  else if(event.pageIndex === this.pageIndex - 1){
  // //     this.lowValue = this.lowValue - this.pageSize;
  // //     this.highValue =  this.highValue - this.pageSize;
  // //    }
  // //     this.pageIndex = event.pageIndex;

  //   this.getDataByPara(event.pageIndex * event.pageSize, 5, 'N');
  //   // this.getDataByPara(event.pageIndex, 5, 'N');
  // }



  // getDataByPara(rowFrom: number, nextRow: number, fromSearch: string): void {
  //   this.log.i(this.TAG, ' getAllProducts');

  //   const SearchParaJSON = [];
  //   const LineUploadJSON = [];

  //   let isSearch = 'N';

  //   if (this.filteredValues['patientChiName'].toString() !== '' ||
  //   this.filteredValues['patientSurname'].toString() !== '' ||
  //   this.filteredValues['patientFirstName'].toString() !== '' ||
  //   this.filteredValues['patientPhone'].toString() !== '' ||
  //   this.filteredValues['patientPhone2'].toString() !== '' ||
  //   this.filteredValues['patientIHKID'].toString() !== '' ||
  //   this.filteredValues['patientMedCard1'].toString() !== ''
  //   ) {
  //     isSearch = 'Y';

  //     const LineUploadJSONRaw = {
  //     };
  //     LineUploadJSON.push(this.filteredValues);

  //     const SearchParaJSONRaw = {
  //       line: LineUploadJSON
  //     };
  //     SearchParaJSON.push(SearchParaJSONRaw);

  //   }


  //   // if (fromSearch === 'Y') {


  //   //   if (this.filteredValues['patientChiName'].toString() !== '' ||
  //   //     this.filteredValues['patientSurname'].toString() !== '' ||
  //   //     this.filteredValues['patientFirstName'].toString() !== '' ||
  //   //     this.filteredValues['patientPhone'].toString() !== '' ||
  //   //     this.filteredValues['patientPhone2'].toString() !== '' ||
  //   //     this.filteredValues['patientIHKID'].toString() !== ''
  //   //     ) {
  //   //       isSearch = 'Y';

  //   //       const LineUploadJSONRaw = {
  //   //       };
  //   //       LineUploadJSON.push(this.filteredValues);

  //   //       const SearchParaJSONRaw = {
  //   //         line: LineUploadJSON
  //   //       };
  //   //       SearchParaJSON.push(SearchParaJSONRaw);

  //   //     }
  //   //     else
  //   //     {
  //   //       this.getAllData();
  //   //       return;
  //   //     }
  //   // }


  //   this.tPatientService.getAllDataWithPatientTypeInfoByRange(rowFrom, nextRow, SearchParaJSON, isSearch).subscribe(data => {

  //     data.forEach(element => {
  //       const patientPhone_d = this.CrypService.decryptStr(element.patientPhone_str);
  //       element.patientPhone = +patientPhone_d;

  //       const patientPhone2_d = this.CrypService.decryptStr(element.patientPhone2_str);
  //       element.patientPhone2 = +patientPhone2_d;

  //       const patientIHKID_d = this.CrypService.decryptStr(element.patientIHKID);
  //       element.patientIHKID = patientIHKID_d.toString();
  //     });

  //     this.dataSource = new MatTableDataSource<tPatientModel>(data);

  //     if (fromSearch === 'Y') {
  //       this.dataSource.paginator = this.paginator;
  //     }


  //   });
  // }




  setDefaultLanguageString(language: String) {
    switch (language) {
      case SystemDefaultModel.Language_Chinese:
          this.unSelectedList = ChineseDefaultModel.UnSelectedList;
          this.showEng = false;
        break;
      case SystemDefaultModel.Language_English:
          this.unSelectedList = EnglishDefaultModel.UnSelectedList;
          this.showEng = true;

          break;
      default:
          this.unSelectedList = ChineseDefaultModel.UnSelectedList;
          this.showEng = false;
          break;
    }
  }


  selectedRecord(selectedPatient: tPatientModel) {
    this.log.i(this.TAG, 'selectedRecord data = ' + selectedPatient.patientChiName);

   // this.tPatientService.selectedPatient = selectedPatient;
    // this.tPatientService.shareSelectedPatient(selectedPatient.patientID);

    // localStorage.removeItem('systemMasterPatientID');
    // localStorage.setItem('systemMasterPatientID', selectedPatient.patientID);
    
    this.activeModal.close(selectedPatient);

  //  this.activeModal.close(selectedPatient);

  }
  closeDialog(){
   // var newPatient=new tPatientModel();
   // newPatient.patientID="newPatient"
    this.activeModal.close("newPatient");
  }
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    // event.key === 'ArrowUp'
    if (event.key === SystemDefaultModel.SaveKey) {
      this.log.i(this.TAG, 'onclick F4');
      this.search();
    }else if (event.key === SystemDefaultModel.ResetKey){
      // this.resetSearch();
    }
  }

  getGender() {
    console.log("do getPatientGender");
    this.SimpleConfigService.getAllData().subscribe((data => {
      console.log("getPatientGender success");

      this.patientTitleList = data.patientGenderTitleModelList;
      this.patientGenderList=data.patientGenderModelList;
    }), err => {
      console.log("getPatientGender error");
    });
  }


  // customFilterPredicate() {
  //   const myFilterPredicate = (data: tPatientModel, filter: string): boolean => {

  //     const searchString = JSON.parse(filter);

  //     return (searchString.patientChiName.toLowerCase() === '' ||
  //       (data.patientChiName != null && data.patientChiName.toString().trim().toLowerCase().indexOf(searchString.patientChiName.toLowerCase()) !== -1))
  //       &&
  //       (searchString.patientPhone.toLowerCase() === '' ||
  //       (data.patientPhone != null && data.patientPhone.toString().trim().toLowerCase().indexOf(searchString.patientPhone.toLowerCase()) !== -1))
  //       &&
  //       (searchString.patientIHKID.toLowerCase() === '' ||
  //       (data.patientIHKID != null && data.patientIHKID.toString().trim().toLowerCase().indexOf(searchString.patientIHKID.toLowerCase()) !== -1))
  //       ;
  //   };
  //   return myFilterPredicate;


  // }

}
